import styled from '@emotion/styled'
import { ListBlock } from '@mehilainen/mds-customer'
import React, { FC, forwardRef, useMemo } from 'react'
import { isMobile } from 'react-device-detect'

import { escapeRegExp } from '../../../utils/text'
import { Text } from '../../Typography/Typography'

const SearchItemNameHighlighted = styled(Text)`
  background: none;
  font-weight: 450;
`
type Props = {
  title: string
  onClick: () => void
  startIcon?: JSX.Element
  endIcon?: boolean
  description?: string
  searchWord?: string
}

export const SearchItem: FC<Props> = ({
  title,
  onClick,
  startIcon,
  endIcon,
  description,
  searchWord,
}) => {
  const re = useMemo(
    () =>
      searchWord && searchWord.length > 0
        ? new RegExp(`(${escapeRegExp(searchWord)})`, 'gi')
        : /(?!)/,
    [searchWord]
  )

  const TitleText = useMemo(
    () =>
      forwardRef<HTMLElement, { children: React.ReactNode; re: RegExp }>(
        ({ children, ...props }, ref) => {
          return (
            <Text ref={ref} {...props}>
              {typeof children === 'string'
                ? children
                    .split(re)
                    .map((part, index) =>
                      re.test(part) ? (
                        <SearchItemNameHighlighted
                          key={`search-item-name-highlight-${part}-${index}`}
                        >
                          {part}
                        </SearchItemNameHighlighted>
                      ) : (
                        part
                      )
                    )
                : children}
            </Text>
          )
        }
      ),
    [re]
  )

  return (
    <ListBlock
      title={title}
      TitleProps={{ component: TitleText }}
      description={description}
      onClick={onClick}
      startIcon={startIcon}
      endIcon={endIcon}
      size={isMobile ? 'small' : 'medium'}
      sx={{ paddingLeft: '16px !important' }}
    />
  )
}

export default SearchItem
